import Icon from './Icon';
import { GATE_MARKS, gateMarkOf, gateTitle } from '../utils/gateMark';

// The draft gate's one mark (stage 3 / C, #332), used by the /drafts queue
// and the review strip: the .badge-compact shape with a 12px icon whose shape
// carries the meaning, so colour is never alone. Red = danger triad, x-circle,
// לתיקון; yellow = warning triad, alert, לבדיקה; green = white with a
// --success-line edge and a plain check (never check-circle — that means
// "approved" in Peak), תקין (owner, 31/10/2026). A held-out green is `—`; pending draws
// nothing. Not interactive: on a phone the row it sits in already opens the
// draft, so the reasons are a desktop `title` only.
//
// `gate` is { gate_state, gate_color, gate_reasons } — a /drafts row, or the
// review screen's POST /:id/gate-view answer. `title` overrides the reasons.
export default function GateMark({ gate, title }) {
  const m = gateMarkOf(gate);
  if (!m) return null;
  if (m.kind === 'hidden') return <span className="gate-mark-none" aria-label="ללא סימון">—</span>;
  const { icon, label } = GATE_MARKS[m.color];
  return (
    <span className={`badge badge-compact gate-mark gate-mark-${m.color}`} title={title ?? gateTitle(gate)}>
      <Icon name={icon} size={12} /> {label}
    </span>
  );
}
